import api from '../../plugins/api';

const createClientUploadLink = ({ dealId, kinds }) => {
  return api.post('/api/crm/clientUpload/createLink', { dealId, kinds });
};

export default createClientUploadLink;
